import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import { useNestedModifiers } from '../NestedModifiersProvider/NestedModifiersProvider'

import { MenuItemDetailsShape } from '../NestedModifiersProvider/Models/MenuItemDetails'
import { ModifierShape } from '../NestedModifiersProvider/Models/Modifier'

import Modal from '../../Modal/Modal'
import CloseButton from '../../CloseButton/CloseButton'
import BackArrow from '../../../assets/back-arrow.svg'

import './ModifiersHeader.css'

export const ModifiersHeader = ({itemDetails}) => {
  const { nestedModifier, popNestedModifier } = useNestedModifiers()

  const clickHandler = useCallback(() => {
    popNestedModifier()
  }, [popNestedModifier])

  const headerText = <Modal.Header>{itemDetails.name}</Modal.Header>

  if (nestedModifier) {
    return (
      <div styleName='headerNavBack'>
        <CloseButton autoFocus onClick={clickHandler}>
          <BackArrow />
        </CloseButton>
        {headerText}
      </div>
    )
  }

  return headerText
}

const itemDetailsShape = PropTypes.oneOfType([MenuItemDetailsShape,
  ModifierShape])

ModifiersHeader.propTypes = {
  itemDetails: itemDetailsShape.isRequired
}
